// @flow
import { LOG_EVENT, LOG_USER_EVENT } from './types';
import type { Action } from './types';

type LogEvent = {
  user_id?: string,
  imei?: string,
  logs: string,
  event_name: string,
}

type LogUserEvent = {
  user: string,
  event_name: string,
  logs: {[key: string]: mixed},
}

export const logEvent = (payload: LogEvent): Action => ({
	type: LOG_EVENT,
	payload,
});

export const logUserEvent = (payload: LogUserEvent): Action => ({
	type: LOG_USER_EVENT,
	payload,
});
